import { Injectable, signal, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { signOut } from 'firebase/auth';

import { State } from '../models/state.model';
import { FirebaseService } from './firebase.service';

const initialState: State = {
  authUser: null,
  currentOrganization: null,
  currentMember: null,
  currentRole: null,
};

@Injectable({
  providedIn: 'root',
})
export class DataStoreService {
  private readonly firebase = inject(FirebaseService);
  private readonly router = inject(Router);

  private readonly _state = signal<State>({ ...initialState });

  readonly authUser = computed(() => this._state().authUser);
  readonly currentOrganization = computed(() => this._state().currentOrganization);
  readonly currentMember = computed(() => this._state().currentMember);
  readonly currentRole = computed(() => this._state().currentRole);

  constructor() {
    let loggedIn = false;
    this.firebase.auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        if (authUser.isAnonymous || authUser.email === null) {
          console.error(
            `[DataStore] signing out user ${authUser.uid}: isAnonymous=${authUser.isAnonymous}, email=${authUser.email}`,
          );
          this.clearState();
          signOut(this.firebase.auth);
          return;
        }

        this.updateState({ authUser });
        loggedIn = true;
      } else {
        this.clearState();
        if (loggedIn) {
          loggedIn = false;
          this.router.navigate(['/login']);
        }
      }
    });
  }

  getProperty<T extends keyof State>(property: T): State[T] {
    return this._state()[property];
  }

  updateState(newState: Partial<State>) {
    this._state.update((current) => ({ ...current, ...newState }));
  }

  clearState() {
    this._state.set({ ...initialState });
  }
}
